import { instanceApi } from './instance';

// Send email with authorization code
export const sendEmailWithAuthCode = (authCode: string): Promise<void> => instanceApi.post(`api/email/authorize-code?email=${authCode}`);

// Send email with authorization link
export const sendEmailWithAuthLink = (authLink: string, type: string): Promise<void> => instanceApi.post(`api/email/authorize-link?email=${authLink}&type=${type}`);
